import axios from '@/utils/http'

/**
 *
 * 获取充值/消费/开户/退卡记录（按照时间、卡号或人）
 * @export
 * @param {*} params
 * @returns
 */
export function GetCardRecordList(params) {
	return axios({
		url: '/CardService/CardRecord/GetCardRecordListV2',
		method: 'get',
		params: {
			...params
		}
	})
}

/**
 *
 * 获取按人充值/消费统计的财务报表（按照时间、卡号或人）
 * @export
 * @param {*} params
 * @returns
 */
export function GetFinanceReportByPerson(params) {
	return axios({
		url: '/CardService/CardRecord/GetFinanceReportByPersonV2',
		method: 'get',
		params: {
			...params
		}
	})
}

/**
 *
 * 获取日充值统计报表
 * @export
 * @param {*} params
 * @returns
 */
export function GetRechargeReportByDate(params) {
	return axios({
		url: '/CardService/CardRecord/GetRechargeReportByDateV2',
		method: 'get',
		params: {
			...params
		}
	})
}

/**
 *
 * 获取日消费统计报表
 * @export
 * @param {*} params
 * @returns
 */
export function GetConsumeReportByDate(params) {
	return axios({
		url: '/CardService/CardRecord/GetConsumeReportByDateV2',
		method: 'get',
		params: {
			...params
		}
	})
}

/**
 *
 * 导出充值消费记录
 * @export
 * @param {*} params
 * @returns
 */
export function DownloadRecordExcel(params) {
	return axios({
		url: '/CardService/CardRecord/GetRechargeAndConsumeExcelV2',
		method: 'get',
		responseType: 'blob',
		params: {
			...params
		}
	})
}

/**
 *
 * 导出个人消费记录
 * @export
 * @param {*} params
 * @returns
 */
export function DownloadReportByPersonExcel(params) {
	return axios({
		url: '/CardService/CardRecord/DownloadReportByPersonExcelV2',
		method: 'get',
		responseType: 'blob',
		params: {
			...params
		}
	})
}

/**
 *
 * 导出日充值记录
 * @export
 * @param {*} params
 * @returns
 */
export function DownloadRechargeReportByDateExcel(params) {
	return axios({
		url: '/CardService/CardRecord/DownloadRechargeReportByDateExcelV2',
		method: 'get',
		responseType: 'blob',
		params: {
			...params
		}
	})
}

/**
 *
 * 导出日消费记录
 * @export
 * @param {*} params
 * @returns
 */
export function DownloadConsumeReportByDateExcel(params) {
	return axios({
		url: '/CardService/CardRecord/DownloadConsumeReportByDateExcelV2',
		method: 'get',
		responseType: 'blob',
		params: {
			...params
		}
	})
}
